import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import ExportButton from "@/components/ExportButton";
import DeleteButton from "@/components/DeleteButton";
import { useAuth } from "@/context/AuthContext";

export default function Genset() {
  const { user } = useAuth();
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ date: new Date().toISOString().slice(0,10), start_time: "", end_time: "", hours: "", fuel_liters: "", notes: "" });

  const load = () => api.get("/genset").then(r => setRows(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      await api.post("/genset", {
        ...form,
        hours: form.hours ? parseFloat(form.hours) : null,
        fuel_liters: form.fuel_liters ? parseFloat(form.fuel_liters) : null,
      });
      toast.success("Genset log saved"); setOpen(false); setForm({ ...form, hours: "", fuel_liters: "", notes: "" }); load();
    } catch { toast.error("Failed"); }
  };

  return (
    <div className="p-4 sm:p-8">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-end justify-between">
          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#6E6E6A]">Log</div>
            <h1 className="font-display text-4xl tracking-tighter font-black">Genset Operations</h1>
          </div>
          <div className="flex gap-2 items-center">
          <ExportButton module="genset" />
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild><Button data-testid="add-genset" className="bg-[#1C1C1A] hover:bg-black text-white"><Plus className="w-4 h-4 mr-2" /> New log</Button></DialogTrigger>
            <DialogContent>
              <DialogHeader><DialogTitle>Genset log</DialogTitle></DialogHeader>
              <div className="grid grid-cols-2 gap-3">
                <div><Label>Date</Label><Input type="date" value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} /></div>
                <div><Label>Hours run</Label><Input type="number" step="0.1" value={form.hours} onChange={(e) => setForm({ ...form, hours: e.target.value })} data-testid="gen-hours" /></div>
                <div><Label>Start time</Label><Input type="time" value={form.start_time} onChange={(e) => setForm({ ...form, start_time: e.target.value })} /></div>
                <div><Label>End time</Label><Input type="time" value={form.end_time} onChange={(e) => setForm({ ...form, end_time: e.target.value })} /></div>
                <div><Label>Fuel (litres)</Label><Input type="number" step="0.1" value={form.fuel_liters} onChange={(e) => setForm({ ...form, fuel_liters: e.target.value })} data-testid="gen-fuel" /></div>
                <div className="col-span-2"><Label>Notes</Label><Input value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} /></div>
              </div>
              <Button onClick={save} data-testid="gen-save" className="mt-4 bg-[#1C1C1A] hover:bg-black text-white">Save</Button>
            </DialogContent>
          </Dialog>
          </div>
        </div>

        <Card className="mt-8 border border-[#D8D8D5] shadow-none rounded-md overflow-hidden">
          <Table>
            <TableHeader><TableRow><TableHead>Date</TableHead><TableHead>Start</TableHead><TableHead>End</TableHead><TableHead>Hours</TableHead><TableHead>Fuel (L)</TableHead><TableHead>By</TableHead>{user?.role === "admin" && <TableHead></TableHead>}</TableRow></TableHeader>
            <TableBody>
              {rows.length === 0 && <TableRow><TableCell colSpan={user?.role === "admin" ? 7 : 6} className="text-center text-[#6E6E6A] py-8">No logs yet</TableCell></TableRow>}
              {rows.map(r => (
                <TableRow key={r.id}>
                  <TableCell>{r.date}</TableCell>
                  <TableCell>{r.start_time || "—"}</TableCell>
                  <TableCell>{r.end_time || "—"}</TableCell>
                  <TableCell className="font-medium">{r.hours ?? "—"}</TableCell>
                  <TableCell>{r.fuel_liters ?? "—"}</TableCell>
                  <TableCell>{r.worker_name}</TableCell>
                  {user?.role === "admin" && (
                    <TableCell><DeleteButton endpoint={`/genset/${r.id}`} label="genset log" onDone={load} testid={`del-gen-${r.id}`} /></TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Card>
      </div>
    </div>
  );
}
